import { CloseOutlined } from "@ant-design/icons";
import { Button } from "antd";

export const CloseBtn = ({ icon, ...others }) => {
  return (
    <Button
      color="danger"
      variant="outlined"
      icon={!icon ? <CloseOutlined /> : icon}
      {...others}
    >
      Cancelar
    </Button>
  );
};
